export default __webpack_public_path__ + "src/images/packages/maliba-lodge/2fc558e23eb39673a2c15af35e06d82a-2.jpeg";